// removed by extract-text-webpack-plugin
module.exports = {"group-container":"RadioGroup__group-container___3XUCl"};